import React from "react";
import { PageHeader as AntPageHeader } from "antd";
import { PageHeaderProps } from ".";

export const PageHeader: React.FC<PageHeaderProps> = (props) => {
  const { children, ...rest } = props;
  return <AntPageHeader {...rest}>{children}</AntPageHeader>;
};
